import { render, staticRenderFns } from "./AppMenu.component.html?vue&type=template&id=9039ae58&scoped=true&external"
import script from "./AppMenu.component.ts?vue&type=script&lang=ts&external"
export * from "./AppMenu.component.ts?vue&type=script&lang=ts&external"
import style0 from "./AppMenu.component.scss?vue&type=style&index=0&id=9039ae58&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9039ae58",
  null
  
)

export default component.exports